import React from "react";
import { Card, Row, Col, Typography } from "antd";
import StatisticsChart from "./StatisticsChart";
import PriorityLeadCard from "./PriorityLeadCard";

const { Text } = Typography;

function AdminCard({ name, place, rating, onBuyNow, onTopPickClick }) {
  return (
    <Row gutter={8}>
      {/* Statistics Card */}
      <Col span={18}>
        <Card
          style={{
            borderRadius: 6,
            background: "#ffff",
            marginBottom: 12,
          }}
        >
          <StatisticsChart />
        </Card>
      </Col>

      {/* Admin User Card */}
      <Col span={6}>
        <PriorityLeadCard
          name={name}
          place={place}
          rating={rating}
          // onBuyNow={onBuyNow}
          onTopPickClick={onTopPickClick}
        />
      </Col>
    </Row>
  );
}

export default AdminCard;
